import { DashboardHeader } from '@/components/dashboard/dashboard-header'
import { DashboardShell } from '@/components/dashboard/dashboard-shell'
import { Skeleton } from '@/components/ui/skeleton'
import { useTRPC } from '@/trpc/react'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { EmployeesDataTable } from '../../employees/(employees_table)/-components/EmployeesDataTable'
import { employeesTableColumns } from '../../employees/(employees_table)/-components/employeesTableColumns'

export const Route = createFileRoute('/dashboard/admin/super_admin/employees/')({
  component: RouteComponent,
})

function RouteComponent() {
  const api = useTRPC()
  const { data: employees, isPending } = useQuery({
    ...api.superAdmin.getAllEmployees.queryOptions(),
  })

  if (isPending)
    return (
      <DashboardShell>
        <DashboardHeader heading="Employees" />
        <Skeleton className="h-40 w-full" />
      </DashboardShell>
    )

  if (!employees) return <div>No employees found</div>

  return (
    <DashboardShell>
      <DashboardHeader heading="Employees" />
      <EmployeesDataTable columns={employeesTableColumns} data={employees} />
    </DashboardShell>
  )
}
